<template lang='pug' src='./home.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Header from 'components/header/header'
import Footer from 'components/footer/footer'

export default {
  name: 'Home',
  computed: {
    props () {
      return this.$store.state.pages['home']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  methods: {
    service1Click () {
      this.$router.push('/new-patients')
      setTimeout(() => {
        this.$scrollTo('#financial-info')
      },
      500)
    }
  },
  components: {
    Loader,
    Header,
    Footer
  },
  data () {
    return {
      swiperOption2: {
        pagination: {
          el: '.swiper-pagination1',
          clickable: true
        },
        centeredSlides: true,
        loop: true,
        spaceBetween: 30,
        grabCursor: true,
        speed: 1000,
        autoplay: {
          delay: 4000
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?68085a8b